<template>
    <v-container fluid grid-list-md>
        <validation-observer ref="observer" v-slot="{ invalid }">
            <v-layout row wrap>
                <v-flex class="pr-lg-1" xs12>
                    <v-card
                        class="
            profile_card
            d-flex
            flex-column
            align-center
            elevation-0
            mx-3
            mt-6
            mb-4
            py-10
            pb-6
          "
                        color="#fff"
                    >
                        <v-col
                            cols="12"
                            lg="6"
                            class="text-center pt-1 px-5 px-lg-0"
                        >
                            <avatar-uploader
                                :request="loadAvatar"
                                :url="userAvatar"
                            ></avatar-uploader>

                            <validation-provider
                                rules="required"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    class="text_field ml-auto mr-auto mt-8 mb-lg-4"
                                    color="#C3D4F3"
                                    label="Currenct password"
                                    type="password"
                                    single-line
                                    outlined
                                    height="70"
                                    dark
                                    hide-details="auto"
                                    v-model="form.current_password"
                                    :error="errors.length > 0"
                                    :error-messages="errors"
                                ></v-text-field>
                            </validation-provider>

                            <validation-provider
                                rules="required|min:8"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    class="text_field ml-auto mr-auto mt-8 mb-lg-4"
                                    color="#C3D4F3"
                                    label="New Password"
                                    type="password"
                                    single-line
                                    outlined
                                    height="70"
                                    dark
                                    hide-details="auto"
                                    v-model="form.password"
                                    :error="errors.length > 0"
                                    :error-messages="errors"
                                ></v-text-field>
                            </validation-provider>

                            <validation-provider
                                rules="required|min:8"
                                v-slot="{ errors }"
                            >
                                <v-text-field
                                    class="text_field ml-auto mr-auto mt-8 mb-lg-4"
                                    color="#C3D4F3"
                                    label="Confirm new password"
                                    single-line
                                    outlined
                                    height="70"
                                    type="password"
                                    dark
                                    hide-details="auto"
                                    v-model="form.password_confirmation"
                                    :error="errors.length > 0"
                                    :error-messages="errors"
                                ></v-text-field>
                            </validation-provider>
                            <v-btn
                                class="update_btn mt-8 mt-lg-6"
                                width="217px"
                                height="70px"
                                color="#76CD68"
                                dark
                                depressed
                                :disabled="updating || invalid"
                                @click="handleUpdate"
                            >
                                Update
                            </v-btn>
                        </v-col>
                    </v-card>
                </v-flex>
            </v-layout>
        </validation-observer>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
    ValidationProvider,
    ValidationObserver,
    extend,
    setInteractionMode
} from "vee-validate";
import { required, min } from "vee-validate/dist/rules";
import AvatarUploader from "../components/AvatarUploader.vue";

setInteractionMode("eager");

extend("required", { ...required, message: "This field is required" });

extend("min", {
    ...min,
    message: "The password must be at least 8 characters"
});

export default {
    name: "Profile",
    components: {
        ValidationProvider,
        AvatarUploader,
        ValidationObserver
    },
    data() {
        return {
            updating: false,
            form: {
                current_password: null,
                password: null,
                password_confirmation: null
            }
        };
    },
    created() {
        this.$root.breadcrumbs = [
            {
                text: "Home",
                href: "/dashboard"
            },
            {
                text: "My profile",
                href: "/profile",
                icon: "../assets/arrow.svg"
            }
        ];
    },

    computed: {
        ...mapGetters("user", ["userAvatar"])
    },

    methods: {
        ...mapActions("user", ["updateUserPassword", "updateUserAvatar"]),

        loadAvatar(form) {
            this.updateUserAvatar(form);
        },

        handleUpdate() {
            this.updating = true;
            this.updateUserPassword(this.form)
                .then(() => {
                    this.updating = false;
                    this.form.current_password = "";
                    this.form.password = "";
                    this.form.password_confirmation = "";
                    this.$refs.observer.reset();
                })
                .catch(() => (this.updating = false));
        }
    }
};
</script>
<style scoped>
.profile_card {
    border-radius: 20px !important;
    overflow: hidden;
}
.text_field {
    max-width: 500px;
}
.v-text-field--outlined >>> fieldset {
    border: 1px solid #c3d4f3;
    border-radius: 20px;
}
.text_field >>> .v-label {
    margin-top: 6px;
    color: #a8b2c5;
    padding: 0px 15px;
    font-size: 18px;
}
.text_field >>> .v-text-field__slot input {
    color: #a8b2c5;
    padding: 0px 15px;
    font-size: 18px;
}
.update_btn {
    font-size: 18px !important;
    font-weight: 500;
    text-transform: none;
    border-radius: 40px;
}
</style>
